import React from "react";
import Styles from './styles.module.scss'
import {useTranslation} from "react-i18next";



const FutureS1 = () => {
    const { t } = useTranslation();

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.title}`}>Future Meta Earth</div>
                <div className={`${Styles.videoWrap}`}>
                    {t('Скоро')}
                </div>
                <div className={`${Styles.note}`}><span>Future Meta Earth</span> — {t('это автономная метавселенная нового поколения, созданная для цифровых личностей Тайм Капсулы. Она сочетает передовые технологии виртуальной среды, искусственного интеллекта и блокчейна, формируя уникальное пространство для существования, взаимодействия и развития цифровых сущностей.')}</div>
            </div>
        </section>
    );
};

export default FutureS1;